module.exports = __webpack_public_path__ + "public/Icons/printer@2x.png?f615be5c";